export default __webpack_public_path__ + "static/media/lantern-right.0b5db41f.webp";